var map = {
	"./1/cover.jpg": "YBXA",
	"./10/cover.jpg": "z/C+",
	"./11/cover.jpg": "0ZaJ",
	"./12/cover.jpg": "OH42",
	"./13/cover.jpg": "g+ou",
	"./14/cover.jpg": "yrvW",
	"./15/cover.jpg": "rsbW",
	"./16/cover.jpg": "PIWd",
	"./17/cover.jpg": "rfpw",
	"./2/cover.jpg": "MLT6",
	"./3/cover.jpg": "1vYR",
	"./4/cover.jpg": "rAKY",
	"./5/cover.jpg": "rLyI",
	"./6/cover.jpg": "67cH",
	"./7/cover.jpg": "QwyF",
	"./8/cover.jpg": "XP2f",
	"./9/cover.jpg": "zf27"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0p5+";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1 ^\.\/.*\/cover\.jpg$
// module id = 0p5+
// module chunks = 27